import { Suspense, useCallback } from 'react';
import { Route, Routes } from 'react-router';

import { MainLayout } from '@/app/layouts/MainLayout';
import { ForbiddenPage } from '@/pages/forbidden';
import { InitPage } from '@/pages/init';
import { LoginPage } from '@/pages/login';
import { NotFoundPage } from '@/pages/notfound';
import {
  getRouteForbidden,
  getRouteLogin,
} from '@/shared/const/router.const.ts';
import { PageLoader } from '@/shared/ui/PageLoader/PageLoader';
import { AppRoutesProps, routes as routePaths } from '../../config/routes';
import { RequireAuth } from '../RequireAuth';

export default function AppRouter() {
  const renderWithWrapper = useCallback((route: AppRoutesProps) => {
    const element = (
      <Suspense fallback={<PageLoader />}>{route.element}</Suspense>
    );
    return (
      <Route
        key={route.path}
        path={route.path}
        element={
          route.authOnly ? (
            <RequireAuth permissions={route.permissions}>{element}</RequireAuth>
          ) : (
            element
          )
        }
      />
    );
  }, []);

  return (
    <Routes>
      <Route path={getRouteLogin()} element={<LoginPage />} />
      <Route path="app" element={<MainLayout />}>
        {/* <Route index element={<BankBranchesPage />} /> */}
        <Route index element={<InitPage />} />
        {/* Render routes as children of the 'app' route */}
        {Object.values(routePaths).map(renderWithWrapper)}
      </Route>
      <Route path={getRouteForbidden()} element={<ForbiddenPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
